import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MfaChallengeForm } from '../components/auth/MfaChallengeForm';

// DEC-RBAC-055: el flujo vive en el store (sessionStorage), no en la URL. Estos search params
// quedan TODOS opcionales como fallback deprecado para deep-links viejos; el componente los lee
// solo si el store está vacío.
const schema = z.object({
    session: z.string().min(1).optional(),
    type: z.enum(['TOTP', 'EMAIL']).optional(),
    email: z.string().email().optional(),
    tenantId: z.string().optional(),
});

export const Route = createFileRoute('/login/mfa-challenge')({
    validateSearch: (s: Record<string, unknown>) => schema.parse(s),
    component: MfaChallengeRoute,
});

function MfaChallengeRoute() {
    const { session, type, email, tenantId } = Route.useSearch();
    // AuthLayout lo provee el parent /login vía <Outlet />.
    return <MfaChallengeForm session={session} type={type} email={email} tenantId={tenantId} />;
}
